module.exports = __webpack_public_path__ + "static/media/team1.c04996a6.jpg";